export default __webpack_public_path__ + "static/media/PrebookModalHeaderStar.6a3ff916.svg";